import type { MenuItemModule } from "../dashboard-app/types"

const menuItemModule: MenuItemModule = {
  menuItems: []
}

export default menuItemModule